import { toDate } from "date-fns";

global.auditOptions = {
    returnDocument: 'after'
}

class audit {
    #collection;
    constructor() {

    }

    registerCollection = (collection) => {
        this.#collection = collection;
        cnsl(true, `Audit collection registered: ${this.#collection}`);
    }

    add = async (collection, _id, document, user, ignoreAtomicity, session) => {
        _id = oid(_id, false);
        // Document is after change
        let operationType = 'update';
        // if (!ignoreAtomicity && !document) operationType = 'insert';
        if (!document) {
            operationType = 'insert';
            document = await _embed(collection, null, _id);
        }
        await conn
            .collection(this.#collection)
            .insertOne({
                user,
                documentId: _id,
                collection,
                operationType,
                document,
                wallTime: toDate(new Date())
            }, { session: session })
    }
}
const auditInstance = new audit();
export default auditInstance;
global._audit = auditInstance.add;

cnsl(true, `[mio-next/mongo] Auditing: auditOptions configured with ${JSON.stringify(auditOptions)}`);


